import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../components/AuthContext";

const AdminRoute = ({ children }) => {
  const { adminUser, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-red-500 border-t-transparent" />
      </div>
    );
  }

  const isAdmin = adminUser?.isAdmin === true && adminUser?.username === "admin";

  if (!isAdmin) {
    const redirectPath =
      location.pathname === "/admin/feedback" ? "/admin/panel" : location.pathname;
    return (
      <Navigate
        to={`/admin/login?redirect=${encodeURIComponent(redirectPath)}`}
        replace
      />
    );
  }

  return children;
};

export default AdminRoute;

